<template>
	<v-row no-gutters v-if="sourceList.length">
		<v-col cols="12">
			<h2 class="reg mt-8">{{ title }}</h2>
			<h4 v-if="subTitle" class="reg">{{ subTitle }}</h4>
			<div class="mt-6">
				<div v-for="(item, index) in sourceList" :key="index">
					<slot name="item" v-bind:item="item">
						{{ item }}
					</slot>
				</div>
			</div>
		</v-col>
	</v-row>
</template>

<script>
export default {
	name: 'SettingsTable',
	props: {
		title: { type: String },
		subTitle: { type: String },
		sourceList: { type: Array },
	},
};
</script>

<style scoped style="scss"></style>
